import type { BadgeVariant } from "@bednbody/ui/components/badge";
import type { SessionAttendanceOutcome, SessionAttendanceState } from "@bednbody/logic";

/**
 * Which `Badge` tone each state and outcome wears.
 *
 * Extracted from the page rather than inlined so both the table and the detail
 * dialog read the same map — the previous version hand-rolled a
 * `rounded-full px-2.5 py-1 text-xs` chip in each file, which frontend-standards
 * §8 forbids precisely because the two copies drift.
 *
 * ⚠ TONE IS NOT A JUDGEMENT ABOUT THE PERSON. `warning` marks a state someone
 * can still act on — not started, running late, paused. A recorded No-Show is
 * `destructive` because it is final, and Off is `muted` because being off is
 * not a deviation. Nothing here decides policy; it colours facts the database
 * already holds.
 */

/** Every state is mapped: an unmapped one would silently render the default. */
export const STATE_VARIANT: Record<SessionAttendanceState, BadgeVariant> = {
  off: "muted",
  awaiting_finalization: "info",
  not_started: "warning",
  pre_start_waiting: "info",
  available: "success",
  paused: "warning",
  emergency_paused: "destructive",
  continuing_responsibility: "info",
  extended: "info",
  session_done: "secondary",
  unable_to_continue: "destructive",
};

export const OUTCOME_VARIANT: Record<SessionAttendanceOutcome, BadgeVariant> = {
  completed: "success",
  late_start: "warning",
  early_end: "warning",
  incomplete: "warning",
  no_show: "destructive",
};
